<template>
  <!-- d2-container 文档 https://doc.d2admin.fairyever.com/zh/sys-components/container.html -->
  <d2-container :filename="filename">
    <el-card style="margin-bottom: 5px" >
      <demo-page-header
        @submit="handleSubmit"
        @detailPrinting="detailPrinting"
        ref="header"/>
    </el-card>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card shadow="always" :body-style="{ padding: '20px'}">
          <div slot="header" class="clearfix">
            <span>空调摊派账单</span>
            <span style="width:100px;float:right">
            </span>
          </div>
          <el-col >
            <el-row  style="padding-bottom: 20px;">
              <table-page-main ref="acFeeDetailsTable"
                              :table-data="BuildTable"
                              :loading="loading"
                               @deleteDateSuccess="addDateSuccess"
                               @dateSuccess="addDateSuccess"
                              @handleSubmit="handleSubmit"
                              />
            </el-row>
            <el-row style="padding-bottom: 20px;">
              <demo-page-footer
                :current="page.current"
                :size="page.size"
                :total="page.total"
                @change="handlePaginationChange"/>
            </el-row>
          </el-col>
        </el-card>
      </el-col>
    </el-row>
  </d2-container>
</template>

<script>
// 组件
import * as qs from "qs";
import {queryAcFeeDetailsAllByLimit} from "@/api/AcFeeDetailsImport";

var _ = require('lodash')
// 请删除下面代码中你不需要的部分
export default {
  name: 'AcFeeDetailsTable',
  components: {
    'DemoPageHeader': () => import('./components/PageHeader/index.vue'),
    'TablePageMain': () => import('./components/AcFeeDetailsTable'),
    'DemoPageFooter': () => import('./components/PageFooter/index.vue')
  },
  // 数据
  data () {
    return {
      filename: __filename,
      BuildTable: [],
      loading: false,
      page: {
        current: 1,
        size: 12,
        total: 0
      }
    }
  },
  mounted () {
    this.$refs.header.handleFormSubmit(false)
  },
  // 事件处理方法
  methods: {
    addDateSuccess () {
      this.$refs.header.handleFormSubmit(false)
    },
    // 分页
    handlePaginationChange (val) {
      this.page = {
        current: val.current,
        size: val.size,
        total: val.total
      }
      // nextTick 只是为了优化示例中 notify 的显示
      this.$nextTick(() => {
        this.$refs.header.handleFormSubmit(false)
      })
    },
    // 查询
    handleSubmit (form, val) {
      this.loading = true
      let obj = _.pickBy(form, _.identity)
      _.unset(obj, 'onOrOff')
      if (val) {
        this.page.current = 1
      }
      obj.executionStatus = 1
      obj.current = this.page.current
      obj.size = this.page.size
      queryAcFeeDetailsAllByLimit (obj)
        .then(res => {
          this.loading = false
          this.BuildTable = res.records
          this.page.total = res.total
        })
        .catch(err => {
          this.loading = false
          this.$notify({
            title: '数据请求异常'
          })
          console.log('err', err)
        })
    },
    detailPrinting () {
      this.$refs.acFeeDetailsTable.selectedObjects()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'AcFeeDetailsTable';
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/TongJiFenXi/AcFeeDetailsTable/AcFeeDetailsTable.vue"
}
</vue-filename-injector>
